import React from 'react';
import styled from 'styled-components';

import useColors from 'hooks/use-colors';

import SvgChevronIcon from 'assets/chevron-icon';
import { Clickable } from 'shared/components';

type BackButtonProps = {
  copy: string;
  onClick: () => void;
};

export function BackButton({ copy, onClick }: BackButtonProps): JSX.Element {
  const colors = useColors();

  return (
    <ButtonContainer onClick={onClick}>
      <SvgChevronIcon fill={colors.primaryBlue} height='7px' />
      <BackCopy>{copy}</BackCopy>
    </ButtonContainer>
  );
}

const ButtonContainer = styled(Clickable)`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
  svg {
    margin: 4px 10px 0 0;
    transform: rotate(90deg);
  }
`;

const BackCopy = styled.span`
  color: ${({ theme }) => theme.colors.primaryBlue};
  font-size: 13px;
  font-weight: bold;
`;
